import React, { useEffect, useRef, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import {
  merch_toggle_off,
  merch_toggle_on,
  user_img,
} from "../../../assets/imgs";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import { edit_icon, eye_icon, user, view_icon } from "../../../assets/imgs";
import { siteListDummy } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL as API, URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const AdminAddCompany = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const type = location?.state?.type;
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const parent_id = JSON.parse(
    localStorage.getItem("user_details") ?? "{}",
  )?.knf_role_id;

  const user_id = JSON.parse(localStorage.getItem("user_details") ?? "{}")?.id;

  console.log("parent_id", parent_id);

  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();
  const [companyID, setCompanyID] = useState(location?.state?.data?.id);
  const [email_verified, setEmail_verified] = useState(0);

  const [roleList, setRoleList] = useState([]);
  const roleRef = useRef([]);
  const createdAt = moment().format("DD-MM-YYYY");

  const comDataObj = {
    companyName: "",
    companyCode: "",
    person: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    siteName: "",
    location: "",
  };

  const [comData, setComData] = useState(comDataObj);

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const [siteErrors, setSiteErrors] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [companyKnfRole, setCompanyKnfRole] = useState({});
  const [locList, setLoclist] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const permissionArr = ["add", "edit", "view", "status", "delete"];
  const [role, setRole] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [selectedPermission_, setSelectedPermission_] = useState([]);

  const permissionRef = useRef([]);

  // const getKfnRole = () => {
  //   post(API.KNF_ADMIN_ROLE)
  //     .then((res) => {
  //       if (res?.status == "success") {
  //         console.log("company_add_res", res);
  //         setCompanyKnfRole(res?.camera_role);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  const specificRoles = (item) => {
    let ids = [...selectedPermissions];
    let temp = [...selectedPermission_];

    let per_ = [];
    item?.permissions?.map((item) => {
      per_.push(item?.id);
    });

    if (selectedPermission_?.includes(item?.id)) {
      let idx = temp?.indexOf(item?.id);
      temp.splice(idx, 1);
      let newArray = ids.filter((item) => !per_.includes(item));
      ids = newArray;
    } else {
      temp.push(item?.id);
      item?.permissions?.map((item) => {
        ids.push(item?.id);
      });
    }
    setSelectedPermission_(temp);
    setSelectedPermissions(ids);
  };

  const handlePermissionToggle = (roleId, parent_id, per_name) => {
    let selectedlist = [];
    let temp = [...selectedPermission_];
    let finder = roleList?.find((i) => i?.id == parent_id);
    let permissions_ = finder?.permissions;
    let permissions_id = finder?.permissions?.map((item) => item?.id);

    selectedPermissions.map((item) => {
      if (item != roleId) {
        selectedlist.push(item);
      }
    });
    if (!selectedPermissions?.includes(roleId)) {
      selectedlist.push(roleId);
    }

    // without list finder and add list id
    let per_name_split = per_name?.split("-");
    if (permissionArr?.includes(per_name_split?.[0])) {
      let listStartWith = permissions_?.find((item) =>
        item?.name?.startsWith("list"),
      );
      if (!selectedlist?.includes(listStartWith?.id)) {
        selectedlist.push(listStartWith?.id);
      }
    }

    // with list finder and remove all persmissom
    if (per_name?.startsWith("list")) {
      if (!selectedlist?.includes(roleId)) {
        let final = selectedlist?.filter(
          (item) => !permissions_id?.includes(item),
        );
        selectedlist = final;
      }
    }

    setSelectedPermissions(selectedlist);

    let matcher = permissions_id?.filter((i) => selectedlist?.includes(i));
    if (permissions_?.length == matcher?.length) {
      temp.push(parent_id);
    } else {
      let inx = temp?.indexOf(parent_id);
      if (inx >= 0) {
        temp.splice(inx, 1);
      }
    }
    setSelectedPermission_(temp);
  };

  const getSiteList = (company) => {
    let formdata = new FormData();
    formdata.append("company_id", company);
    post(API.SITE_LIST_ADMIN, formdata)
      .then((res) => {
        // setPagination(res?.pagination_meta);
        setSiteList(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocationList = () => {
    get(API.KNF_COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getPermissionsList = async () => {
    get(URL.PERMISSIONS_LIST)
      .then((res) => {
        if (res?.status == "success") {
          let filert_ = res?.modules?.filter((i) => i?.type == 4);

          let temp = [];

          filert_?.map((item) => {
            let permissions_ = [];

            item?.permissions?.map((per) => {
              let obj_per = {
                ...per,
              };

              if (per?.name?.includes("Knf Company")) {
                if (per?.name?.includes("-knf admin")) {
                  obj_per.name = per?.name?.replace(
                    "-knf admin",
                    "-aiware admin",
                  );
                } else {
                  obj_per.name = per?.name?.replace("Knf Company", "Aiware");
                }
              } else if (per?.name?.includes("knf super admin")) {
                obj_per.name = per?.name?.replace(
                  "knf super admin",
                  "aiware super admin",
                );
              }

              if (per?.name?.includes("Knf Company")) {
                obj_per.name = per?.name?.replace("Knf Company", "Aiware");
              } else if (per?.name?.includes("knf admin")) {
                obj_per.name = per?.name?.replace("knf", "aiware admin");
              }

              permissions_.push(obj_per);
            });

            let obj = {
              ...item,
              permissions: permissions_,
            };

            if (item?.name?.includes("Knf Company")) {
              if (item?.name == "Knf Admin") {
                obj.name = "Aiware Admin";
              } else {
                obj.name = item?.name?.replace("Knf Company", "Aiware");
              }
            } else if (item?.name?.includes("Knf Super Admin")) {
              obj.name = item?.name?.replace(
                "Knf Super Admin",
                "Aiware Super Admin",
              );
            }

            temp.push(obj);
          });

          console.log("temp", temp);

          const arrPer = ["Company Alert Types", "Company Camera"];

          const fullArr = [
            ...temp.filter((i) => !arrPer.includes(i.name)),
            ...temp.filter((i) => arrPer.includes(i.name)),
          ];
          setRoleList(fullArr);
          roleRef.current = fullArr;
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  console.log("roleList", roleList);

  const getView = () => {
    get(API.KNF_COMPANY_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.data;

        if (data?.knf_user?.email_verified) {
          setEmail_verified(data?.knf_user?.email_verified);
        }

        if (data?.logo) {
          setLogo(data?.logo);
          setLogoPreview(data?.logo);
        }

        let ob = {
          companyName: "",
          companyCode: "",
          person: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
          siteName: "",
          location: "",
        };

        if (data?.company_name) {
          ob.companyName = data?.company_name;
        }

        if (data?.company_code) {
          ob.companyCode = data?.company_code;
        }

        if (data?.knf_user?.name) {
          ob.person = data?.knf_user?.name;
        }

        if (data?.knf_user?.email) {
          ob.email = data?.knf_user?.email;
        }

        if (data?.knf_user?.phone) {
          ob.mobile = data?.knf_user?.phone;
        }

        if (data?.location) {
          ob.location = data?.location;
        }

        if (data?.knf_user?.role_data) {
          setCompanyKnfRole(data?.knf_user?.role_data);
        }

        setComData(ob);

        if (data?.knf_user?.profile_image) {
          setOwnerImg(data?.knf_user?.profile_image);
          setOwnerImgPreview(data?.knf_user?.profile_image);
        }

        if (data?.knf_user?.role_data?.permissions?.length > 0) {
          const permissionIds = data?.knf_user?.role_data?.permissions.map(
            (item) => item,
          );

          console.log("permissionIds", permissionIds);

          setSelectedPermissions(permissionIds);
          permissionRef.current = permissionIds;

          // let parentIds = [];

          // roleRef.current?.forEach((module) => {
          //   const modulePermissionIds = module.permissions.map((p) => p.id);
          //   console.group("check");
          //   console.log("modulePermissionIds", modulePermissionIds);
          //   console.log("permissionIds", permissionIds);
          //   const allSelected = modulePermissionIds.every((id) =>
          //     permissionIds.includes(id),
          //   );
          //   console.log("allSelected", allSelected);
          //   console.groupEnd();

          //   if (allSelected) {
          //     parentIds.push(module.id);
          //   }
          // });

          // console.log("parentIds", parentIds);

          // setSelectedPermission_(parentIds);
        }

        setEmailCheckFlag(1);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (roleList?.length > 0 && selectedPermissions?.length > 0) {
      let parentIds = [];

      roleList.forEach((module) => {
        const modulePermissionIds = module?.permissions?.map((p) => p.id) || [];

        const allSelected =
          modulePermissionIds.length > 0 &&
          modulePermissionIds.every((id) => selectedPermissions.includes(id));

        if (allSelected) {
          parentIds.push(module.id);
        }
      });

      setSelectedPermission_(parentIds);
    }
  }, [roleList, selectedPermissions]);

  const roleView = async (id) => {
    console.log("roleViewId", id);
    get(URL.VIEW_ROLE + id)
      .then((res) => {
        if (res?.status == "success") {
          setRole(res?.role_data?.name);
          setSelectedPermissions(res?.role_data?.permissions);
          let temp = [];
          res?.role?.permissions?.map((item, ind) => {
            temp.push(item?.id);
          });
          // setPermissions(temp);

          let permissions_ = [...res?.role_data?.permissions];
          let parent_id = [];
          res?.modules?.map((item, ind) => {
            let finder = item?.permissions?.filter((i) =>
              permissions_?.includes(i?.id),
            );
            if (item?.permissions?.length == finder?.length) {
              parent_id.push(item?.id);
            }
          });
          setSelectedPermission_(parent_id);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    // console.log(res);
  };

  const getRoles = () => {
    let formdata = new FormData();
    formdata.append("page", 1);
    formdata.append("type", 4);
    formdata.append("search", "");
    formdata.append("admin", "admin");

    post(URL.KNF_ROLES_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          let arr = res?.lists?.filter((i) => !i.company_id);

          console.log("arr", arr);
          if (arr.length > 0 && type == "add") {
            let { id } = arr[0];
            // console.log("id", id);
            roleView(id);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    // getKfnRole();
    getLocationList();
    getRoles();
    getPermissionsList();
    if (location?.state?.data?.id) {
      getView();
      getSiteList(location?.state?.data?.id);
    }
  }, []);

  console.log("PersmissionSelecetd", selectedPermissions);

  const validate = () => {
    const newErrors = {};
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (comData?.companyName?.length == 0)
      newErrors.companyName = "Company Name is required";
    if (comData?.companyCode?.length == 0)
      newErrors.companyCode = "Company Code is required";
    if (comData?.location?.length == 0)
      newErrors.location = "Location is required";
    if (comData?.email?.length == 0 || !emailRegex.test(comData?.email))
      newErrors.email = "Valid Email is required";
    if (!comData?.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!singaporeMobileRegex.test(comData?.mobile)) {
      newErrors.mobile = "Enter valid 8-digit Singapore mobile number";
    }
    // if (
    //   !comData?.mobile ||
    //   (comData?.mobile?.length !== 8 && comData?.mobile?.length !== 10)
    // ) {
    //   newErrors.mobile = "Enter valid 8-digit or 10-digit mobile number";
    // }
    if (comData?.person?.length == 0)
      newErrors.person = "Person Name is required";

    if (!companyID) {
      // if (comData?.password?.length == 0 || comData?.password.length < 6)
      //   newErrors.password = "Password must be at least 6 characters";
      // if (comData?.confirmPassword !== comData?.password)
      //   newErrors.confirmPassword = "Passwords do not match";
      // if (!logo) newErrors.logo = "Company Logo is required";
      // if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    if (/[^a-zA-Z0-9 ]/.test(e.target.value)) {
      return;
    }

    if (e.target.value.length > 30) {
      toast("Form Fields cannot exceed 30 characters");
      return;
    }

    const { name, value } = e.target;
    // if (comData?.email?.length < 0) {
    //   setEmailCheckData({});
    // }
    setComData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setSiteErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSiteChange = (id, field, value) => {
    setSiteList((prev) =>
      prev.map((site) => (site.id === id ? { ...site, [field]: value } : site)),
    );
    // clear site error
    setSiteErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = () => {
    if (validate()) {
      const formdata = new FormData();
      formdata.append("name", comData?.person);
      formdata.append("company_name", comData?.companyName);
      formdata.append("company_code", comData?.companyCode);
      formdata.append("email", comData?.email);
      formdata.append("parent_role_id", parent_id);
      // formdata.append("created_by", user_id);
      if (type !== "add") {
        formdata.append("knf_role_id", companyKnfRole?.id);
      }
      formdata.append("phone", comData?.mobile);

      // console.group("FormPermission-->");
      // console.log("permissionRefForm", permissionRef.current);
      // console.log("selectedPermissionsForm", selectedPermissions);

      const isEqual =
        JSON.stringify([...selectedPermissions].sort()) ===
        JSON.stringify([...permissionRef.current].sort());
      if (!isEqual) {
        formdata.append("permissions", selectedPermissions);
      }
      // console.log("isEqual", isEqual);
      // console.groupEnd();

      // return;

      formdata.append("location", comData?.location);
      if (logo?.name) {
        formdata.append("logo", logo);
      }
      if (ownerImg?.name) {
        formdata.append("profile_image", ownerImg);
      }
      formdata.append("knf_type", 1);

      // for (let [key, value] of formdata.entries()) {
      //   console.log(`${key},${value}`);
      // }

      // console.log('slecetedPermissions--->',selectedPermissions)

      // return;

      if (companyID) {
        // formdata.append("_method", "PATCH");
        post(API.COMPANY_EDIT + companyID, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/admin-company-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(API.COMPANY_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/admin-company-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      //   console.log("Submit successful", comData);
    }
  };

  const [logoPreview, setLogoPreview] = useState(null);
  const [ownerImgPreview, setOwnerImgPreview] = useState(null);

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      // Check file size (5MB limit)
      if (image.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        return;
      }

      // Check file type
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(image.type)) {
        toast.error("Only JPG, JPEG, PNG files are allowed");
        return;
      }

      setLogo(image);
      setLogoPreview(window.URL.createObjectURL(image)); // Create preview URL
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      // Check file size (5MB limit)
      if (image.size > 5 * 1024 * 1024) {
        toast.error("File size should be less than 5MB");
        return;
      }

      // Check file type
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(image.type)) {
        toast.error("Only JPG, JPEG, PNG files are allowed");
        return;
      }

      setOwnerImg(image);
      setOwnerImgPreview(window.URL.createObjectURL(image)); // Create preview URL
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  useEffect(() => {
    return () => {
      if (logoPreview) {
        window.URL.revokeObjectURL(logoPreview);
      }
      if (ownerImgPreview) {
        window.URL.revokeObjectURL(ownerImgPreview);
      }
    };
  }, [logoPreview, ownerImgPreview]);

  const autoFetchData = (data) => {
    console.log("autoFetchData", data);
    setEmailCheckData(data);
    let ob = {
      companyName: "",
      companyCode: "",
      person: "",
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",
      siteName: "",
      location: "",
    };

    if (data?.company?.id) {
      setCompanyID(data?.company?.id);
    }

    if (data?.company?.logo) {
      setLogo(data?.company?.logo);
      setLogoPreview(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.companyName = data?.company?.name;
    }

    if (data?.company?.company_code) {
      ob.companyCode = data?.company?.company_code;
    }

    if (data?.user?.name) {
      ob.person = data?.user?.name;
    }

    if (data?.email) {
      ob.email = data?.email;
    } else {
      ob.email = comData?.email;
    }

    if (data?.user?.phone) {
      ob.mobile = data?.user?.phone;
    }
    if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    setComData(ob);
    if (data?.user?.profile_image) {
      setOwnerImg(data?.user?.profile_image);
      setOwnerImgPreview(data?.user?.profile_image);
    }
  };

  const emailCheck = () => {
    let formdata = new FormData();
    if (comData?.email?.length > 0) {
      formdata.append("email", comData?.email);
      post(API.EMAIL_CHECK, formdata)
        .then((res) => {
          setEmailCheckFlag(1);
          if (res?.userData?.length > 0) {
            let data = res?.userData?.[0];
            console.log("data-->check", data);
            if (data?.knf_type == 1) {
              autoFetchData(data);
            } else if (data?.knf_type == null) {
              autoFetchData(data);
            } else {
              toast.error("Email ID already exists");
            }
          } else {
            let ob = {
              ...comDataObj,
              email: comData.email,
            };
            setComData(ob);
            setOwnerImg(null);
            setLogo(null);
            setEmailCheckData({});
            setLogoPreview(null);
            setOwnerImgPreview(null);
            toast("please enter all required fields to add company");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  // console.log("email_verified", email_verified);
  // console.log("selectedPermissions", selectedPermission_);

  const companyLogoRef = useRef(null);
  const personImageRef = useRef(null);

  return (
    <div className="dashRightView">
      <StatusComp name={"Company"} type={type} />

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <div className="d-flex w-100 ac-jb">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Primary Email ID<span className="text-danger">*</span>
            </p>
            {type == "edit" && (
              <p className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-12 mb-1 text-primary mx-2">
                {email_verified
                  ? "Email Verified"
                  : "Email Verification pending"}
              </p>
            )}
          </div>
          <div className="d-flex">
            <input
              className="input-box"
              name="email"
              value={comData?.email}
              onChange={(even) => {
                const value = even.target.value;

                if (value.length > 50) {
                  toast.error("Email cannot exceed 50 characters");
                  return;
                }

                setComData((prev) => ({
                  ...prev,
                  email: value,
                }));
                setLogo("");
                setOwnerImg("");
                setLogoPreview(null);
                setOwnerImgPreview(null);
                setEmailCheckFlag(0);
              }}
              type="email"
              placeholder="Primary Email id"
              // disabled={type == "edit" ? true : false}
            />
            {/* {email_verified == 0 && ( */}
            {/* {comData?.email?.length > 1 && ( */}
            <button
              className={`email_check_btn ${
                !emailRegex?.test(comData?.email) ? "opacity-50" : ""
              }`}
              disabled={
                comData?.email?.length == 0
                  ? true
                  : // : type == "edit"
                    // ? true
                    false
              }
              onClick={() => emailCheck()}
            >
              Check
            </button>
            {/* )} */}
          </div>
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        {emailCheckFlag == 1 && (
          <>
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Company name<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="companyName"
                value={comData?.companyName}
                onChange={handleChange}
                type="text"
                placeholder="Company name"
                disabled={
                  emailCheckData?.company?.name
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {errors?.companyName && (
                <p className="err">{errors?.companyName}</p>
              )}
            </div>
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Company Code<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="companyCode"
                value={comData?.companyCode}
                onChange={handleChange}
                type="text"
                placeholder="Company Code"
                disabled={
                  emailCheckData?.company?.company_code
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {errors?.companyCode && (
                <p className="err">{errors.companyCode}</p>
              )}
            </div>
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                Location<span className="text-danger">*</span>
              </p>
              <select
                name="location"
                value={comData?.location}
                onChange={handleChange}
                className="input-box"
                type="text"
                disabled={
                  emailCheckData?.company?.location
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              >
                <option>Select Location</option>
                {locList?.map((item) => {
                  return (
                    <option value={item?.id} key={item?.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              {errors.location && <p className="err">{errors.location}</p>}
            </div>
            {type == "add" && (
              <>
                {logo != "" ? (
                  <div className="col-md-5 d-flex ac-js">
                    <div>
                      <input
                        ref={companyLogoRef}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleLogoChange}
                      />
                      <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                        Company Logo
                      </p>
                      <img
                        src={logoPreview || logo || user_img}
                        alt="Company Logo"
                        className="user"
                        style={{
                          borderRadius: "50px",
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={edit_icon}
                        alt="Edit"
                        className="edit-btn mt-4 pointer"
                        onClick={() => companyLogoRef.current?.click()}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-md-5">
                    <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                      Company Logo (size 2 MB)
                    </p>
                    <span className="text-danger fs-12">
                      JPG, JPEG, PNG only | Max size: 5MB
                    </span>
                    <input
                      ref={companyLogoRef}
                      className="input-box"
                      name="logo"
                      onChange={handleLogoChange}
                      type="file"
                      placeholder="Company Logo"
                      accept="image/*"
                    />
                    {/* Preview for newly uploaded logo */}
                    {logoPreview && (
                      <div className="mt-2">
                        <img
                          src={logoPreview}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            {type != "add" && (
              <div className="col-md-5">
                <div className="mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Company logo
                  </p>
                  <span className="text-danger fs-12">
                    JPG, JPEG, PNG only | Max size: 5MB
                  </span>
                </div>

                {logo ? (
                  <img
                    src={logo?.name ? logoPreview : logo}
                    alt=""
                    className="user"
                    style={{
                      borderRadius: "50px",
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <img src={user} alt="" className="user" />
                )}
                {type != "view" && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="edit-logo"
                      onChange={handleLogoChange}
                      disabled={
                        emailCheckData?.company?.logo
                          ? true
                          : emailCheckFlag == 0
                            ? true
                            : false
                      }
                    />

                    <button
                      onClick={() =>
                        document.getElementById("edit-logo").click()
                      }
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                    </button>
                  </>
                )}
              </div>
            )}

            {type == "add" && (
              <>
                {ownerImg != "" ? (
                  <div className="col-md-5 d-flex ac-js">
                    <input
                      ref={personImageRef}
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handlePrimaryImg}
                    />
                    <div>
                      <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                        Primary person image
                      </p>
                      <img
                        src={ownerImgPreview || ownerImg || user_img}
                        alt="Primary Person"
                        className="user"
                        style={{
                          borderRadius: "50px",
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={edit_icon}
                        alt="Edit"
                        className="edit-btn mt-4 pointer"
                        onClick={() => personImageRef.current?.click()}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-md-5">
                    <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                      Primary person image (size 2 MB)
                    </p>
                    <span className="text-danger fs-12">
                      JPG, JPEG, PNG only | Max size: 5MB
                    </span>
                    <input
                      ref={personImageRef}
                      className="input-box"
                      name="ownerImg"
                      onChange={handlePrimaryImg}
                      type="file"
                      placeholder="Primary Person Image"
                      accept="image/*"
                      disabled={
                        emailCheckData?.profile_url
                          ? true
                          : emailCheckFlag == 0
                            ? true
                            : false
                      }
                    />
                    {/* Preview for newly uploaded image */}
                    {ownerImgPreview && (
                      <div className="mt-2">
                        <img
                          src={ownerImgPreview}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            {type != "add" && (
              <div className="col-md-5">
                <div className="mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Primary person image
                  </p>
                  <span className="text-danger fs-12">
                    JPG, JPEG, PNG only | Max size: 5MB
                  </span>
                </div>

                <img
                  src={
                    ownerImg
                      ? ownerImg?.name
                        ? window.URL.createObjectURL(ownerImg)
                        : ownerImg
                      : user
                  }
                  alt=""
                  className="user"
                  style={{
                    borderRadius: "50px",
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
                {type !== "view" && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="edit-logo1"
                      onChange={handlePrimaryImg}
                    />

                    <button
                      onClick={() =>
                        document.getElementById("edit-logo1").click()
                      }
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                    </button>
                  </>
                )}
              </div>
            )}
            {console.log("emailCheckData", emailCheckData)}

            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Primary person<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="person"
                value={comData?.person}
                onChange={handleChange}
                type="text"
                placeholder="Primary person"
                disabled={
                  emailCheckData?.user?.name
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {errors.person && <p className="err">{errors.person}</p>}
            </div>

            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                Primary Singapore Mobile number
                <span className="text-danger">*</span>
              </p>
              <input
                name="mobile"
                value={comData?.mobile}
                maxLength={8}
                onChange={(e) => {
                  let val = e.target.value;

                  if (!/^\d*$/.test(val)) {
                    return;
                  }

                  handleChange(e);
                }}
                className="input-box"
                type="text"
                max={8}
                placeholder="+65 Mobile number"
                disabled={
                  emailCheckData?.user?.phone
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>
          </>
        )}
      </div>

      <div>
        <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  black mt-3">
          Permissions
        </p>
      </div>

      {emailCheckFlag == 1 && (
        <div className="d-flex flex-wrap mt-2 ps-3 gap-2">
          {roleList?.map((item, id) => {
            const allowedItems = ["Company Alert Types", "Company Camera"];

            const isAllowed = allowedItems.includes(item?.name);

            // console.log("roleList", roleList);

            return (
              <div
                className={`w-24 mt-3 role-box ${
                  !isAllowed ? "opacity-50" : ""
                }`}
                key={id}
                style={{
                  pointerEvents: isAllowed ? "auto" : "none",
                }}
              >
                <div className="d-flex ac-js gap-2 mb-3">
                  <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
                    {item?.name}
                  </p>

                  {type != "view" && (
                    <img
                      src={
                        selectedPermission_?.includes(item?.id)
                          ? merch_toggle_on
                          : merch_toggle_off
                      }
                      className="roles-icon pointer"
                      alt=""
                      onClick={() => {
                        if (isAllowed) {
                          specificRoles(item);
                        }
                      }}
                    />
                  )}
                </div>

                <div className="d-flex ac-js">
                  <div>
                    {item?.permissions?.map((permission, index) => {
                      // console.log("permission", permission);
                      // console.log("selectedPermissions", selectedPermissions);
                      const isSelected = selectedPermissions?.includes(
                        permission.id,
                      );

                      return (
                        <div className="d-flex ac-js gap-2 mb-2" key={index}>
                          <img
                            src={
                              isSelected ? merch_toggle_on : merch_toggle_off
                            }
                            className="roles-icon pointer"
                            alt=""
                            onClick={() => {
                              if (isAllowed) {
                                handlePermissionToggle(
                                  permission.id,
                                  item?.id,
                                  permission?.name,
                                );
                              }
                            }}
                          />

                          <p className="f1 fs-xs-10 trans fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 mb-0">
                            {permission?.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {(givenpermissions?.includes("CAN-Add-KNF_ADMIN_COMPANY") ||
          givenpermissions?.includes("CAN-Edit-KNF_ADMIN_COMPANY")) &&
          type != "view" && (
            <>
              {emailCheckData?.id ? (
                <button
                  onClick={handleSubmit}
                  className={` submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckData?.email == comData?.email ? "" : "opacity-50"
                  }`}
                  disabled={
                    emailCheckData?.email == comData?.email ? false : true
                  }
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckFlag == 1 ? "" : "opacity-50"
                  }`}
                  disabled={emailCheckFlag == 1 ? false : true}
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              )}
            </>
          )}
      </div>

      {type == "view" && !show && (
        // <button onClick={() => setShow(true)} className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
        //     Add Site
        // </button>
        <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17  mt-4 primary">
          Site List
        </p>
      )}

      {show && (
        <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mt-4 primary">
          Site List
        </p>
      )}

      {givenpermissions?.includes("CAN-List-KNF_ADMIN_SITE") &&
        type !== "add" && (
          <div className="container mt-4">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Site Name & Code</th>
                  <th>Site Location</th>
                  <th>Site Admin</th>
                  <th>Created On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {siteList?.map((item, ind) => (
                  <tr key={ind} className="text-center">
                    <td>{ind + 1}</td>
                    <td>
                      <div>{item?.site_name}</div>
                      <div className="text-muted">{item?.site_code}</div>
                    </td>
                    <td>{item?.site_location}</td>
                    <td>
                      {/* <div>kbf admin</div> */}
                      <div className="text-muted">{item?.user_email}</div>
                      <div className="text-muted">{item?.user_phone}</div>
                    </td>
                    <td>
                      <div className="text-muted">
                        {item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : ""}
                      </div>
                    </td>
                    <td className="d-flex ac-jc gap-4">
                      <button
                        onClick={() => {
                          navigate("/sites-view", {
                            state: { type: "view", data: item },
                          });
                        }}
                        className="cust-btn "
                      >
                        <img src={view_icon} alt="" className=" edit-btn " />
                      </button>

                      <button
                        className={`${
                          item?.status ? "active-btn" : "deactive-btn"
                        } w-100 border-0 opacity-50`}
                      >
                        {item?.status ? "Active" : "De-active"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};

export default AdminAddCompany;
